import { colors, radius } from '@/theme/tokens';

interface AppToggleSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  'aria-label'?: string;
  'data-testid'?: string;
}

export function AppToggleSwitch({
  checked,
  onChange,
  'aria-label': ariaLabel,
  'data-testid': dataTestId,
}: AppToggleSwitchProps) {
  return (
    <button
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      data-testid={dataTestId}
      onClick={() => onChange(!checked)}
      style={{
        width: 44,
        height: 24,
        borderRadius: radius.full,
        backgroundColor: checked ? colors.accent : colors.border,
        border: 'none',
        padding: 2,
        cursor: 'pointer',
        transition: 'background-color 150ms ease',
        flexShrink: 0,
      }}
    >
      <div
        style={{
          width: 20,
          height: 20,
          borderRadius: radius.full,
          backgroundColor: colors.white,
          transform: checked ? 'translateX(20px)' : 'translateX(0)',
          transition: 'transform 150ms ease',
        }}
      />
    </button>
  );
}
